import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'upsc-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss']
})
export class CallbackComponent implements OnInit {

  constructor(
    private auth: AuthService,
    private router: Router
  ) { }

  ngOnInit() {
    if (sessionStorage.getItem('ssp-landing-page')) {
      const target = sessionStorage.getItem('ssp-landing-page');
      this.router.navigateByUrl(target || '/');
    }
    this.auth.appState$.subscribe(appState => {
      if (appState?.target) {
        this.router.navigateByUrl(appState.target);
      }
    });
  }

}
